<latch-floor-group-list
  [elevatorName]="data.elevatorName"
  [elevatorDetails]="data.elevatorDetails"
  [selectedFloorGroup]="data.selectedFloorGroup"
  [defaultFloorGroup]="data.defaultFloorGroup"
  (cancel)="onBackClick()">
</latch-floor-group-list>
